import React, { FunctionComponent, ReactNode, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import Body from '@bitcoin-portal/verse-web-components/dist/Body';
import Button from '@bitcoin-portal/verse-web-components/dist/Button';
import H5 from '@bitcoin-portal/verse-web-components/dist/H5';

import { useFarms } from '@context/providers/FarmsProvider';

import { useTrackedState } from '../../../../context/store';

import { NoLiquidityWrapper } from './styled';

interface Props {
  userAccount?: string;
  onConnectWallet?: () => void;
  title: string;
  message: string;
  buttonText: string;
  link?: (children: ReactNode) => ReactNode;
  singleSided?: boolean;
}

export const NoLiquidity: FunctionComponent<Props> = ({
  userAccount,
  onConnectWallet,
  title,
  message,
  buttonText,
  singleSided,
  link = () => <></>,
}) => {
  const { selectedLiquidityPair: pair } = useTrackedState();
  const { selectedFarm } = useFarms();

  const pairName = singleSided
    ? `${selectedFarm.pair.name}`
    : `${pair.token0?.symbol} / ${pair.token1?.symbol}`;

  const button = useMemo(
    () => (
      <Button as="div" small>
        <FormattedMessage
          id={buttonText}
          values={{
            PAIR: pairName,
          }}
        />
      </Button>
    ),
    [pairName],
  );

  return (
    <NoLiquidityWrapper>
      <H5 style={{ paddingBottom: '8px' }}>
        <FormattedMessage id={title} />
      </H5>
      <Body style={{ textAlign: 'center' }}>
        <FormattedMessage
          id={message}
          values={{
            PAIR: pairName,
          }}
        />
      </Body>
      {!userAccount ? (
        <Button
          small
          onClick={() => {
            if (typeof onConnectWallet === 'function') onConnectWallet();
          }}
        >
          <FormattedMessage id={buttonText} />
        </Button>
      ) : (
        link(button)
      )}
    </NoLiquidityWrapper>
  );
};

export default NoLiquidity;
